import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { SearchConversationsParams } from '@common/api/conversations/useSearchConversations';

export const conversations = createQueryKeys('conversations', {
	list: (servicesProviderId: string, params?: SearchConversationsParams) => ({
		queryKey: [servicesProviderId, params],
	}),

	facets: (servicesProviderId: string, params?: SearchConversationsParams) => ({
		queryKey: [servicesProviderId, params],
	}),

	stats: (servicesProviderId: string) => ({
		queryKey: [servicesProviderId],
	}),

	messages: (servicesProviderId: string, leadId: string, conversationId: string) => ({
		queryKey: [servicesProviderId, leadId, conversationId],
	}),
});
